import React, {useEffect} from 'react';
import VStack from "../../../../../common/Layout/VStack";
import BasicInformation from "./BasicInformation";
import {isBoxInTrial, isMobile} from "../../../../../../services/Helpers";
import Box from "../../../../../common/Layout/Box";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {Divider} from "antd";
import {t} from "../../../../../../services/i18n";
import AvailabilitySlotSelection from "./AvailabilitySlotSelection";
import RepeatConfiguration from "./RepeatConfiguration";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {USERS_SELECT} from "../../../../../../services/ConstHelper";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import {CREATE_USER_MODAL, openModal, updateModalRes} from "../../../../../../redux/modalManagerSlice";
import {Colors} from "../../../../../../styles/Colors";
import ProTipBox from "../../../../../common/ProTipBox";
import {useDispatch, useSelector} from "react-redux";
import {addToSelectionsTree} from "../../../../../../redux/stepperSlice";
import {useNavigate} from "react-router-dom";

const BasicInfoAppointment = (props) => {
    const { values, setFieldValue, setValues, errors, touched, validationObject, target, fromAvailability, ...additional} = props;
    const selectionTree = useSelector(state => state.stepper.selectionsTree)
    const createUserModalRes = useSelector(state => state.modalManager.createUserModal.processRes)
    const editType = useSelector((state) => state.stepper.editType);
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        console.log(values, errors)
    }, [values, errors]);

    useEffect(() => {
        if(createUserModalRes) {
            onUserSelected({...createUserModalRes, label: createUserModalRes.full_name, membership_user: []})
            dispatch(updateModalRes({modalName: CREATE_USER_MODAL, res: null}))
        }
    }, [createUserModalRes]);

    const onUserSelected = (user) => {
        setValues({
            ...values,
            scheduleUser: {
                ...(values.scheduleUser ?? {}),
                user_fk: user?.user_fk,
                membership_user_fk: null,
                isLead: user?.type === 'lead',
                isNoMembership: false,
                isUserActive: user?.active
            }
        })
        const memberships = user?.membership_user
            .filter(item => !((item.sessions_left === 0 && user?.active) && item.membership_types.type === 'session'))
            .filter(item => user.active ? item.active : !item.active)
        const newUser = user ? {...user, membership_user: memberships} : null

        dispatch(addToSelectionsTree({user: newUser}))
    }

    return (
        <VStack space={'1rem'}>
            <VStack space={'1rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.heading2Mobile} boldFont>{t('basic-info-section-header')}</AppText>
                <Divider style={{ margin: 0 }}/>
                <Box style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '1rem' }}>
                    {(editType || values.waitlist_id) ?
                        <VStack space={'0.2rem'} w={'100%'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('select-client')}*</AppText>
                            <AdvanceSelect options={[{...values.bookedUser, label: values.bookedUser?.full_name, value: values.bookedUser?.user_fk}]} initValue={values.bookedUser?.user_fk} isDisabled={true}/>
                        </VStack>
                        :
                        <VStack space={'0.2rem'} w={'100%'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('select-client')}*</AppText>
                            <AdvanceSelect initValue={values.scheduleUser?.user_fk}
                                           type={USERS_SELECT}
                                           onChange={onUserSelected}
                                           value={selectionTree['user']}
                                           isClearable={true}
                                           hideFreefitType
                                           hideCustomerId={isMobile}
                                           allowInactive
                                           getInactiveMemberships
                                           placeholder={t('appointment-user-select-placeholder')}
                                           smallSelectionDesign
                                           testID={'create-event-client'}
                                           showSelectedUserWithStatus
                                           isError={!!(touched.scheduleUser?.user_fk && errors.scheduleUser?.user_fk)}
                            />
                            <CustomButtonV2 onClick={() => dispatch(openModal({modalName: CREATE_USER_MODAL, props: {navigate, viaFunnel: true, initialValues: {locations_box_fk: values.locations_box_fk}, displayProps: {showPersonalId: true}}}))}
                                            text={`+ ${t('add-new-client')}`}
                                            applyHoverOnText={true}
                                            type={'link'}
                                            style={{justifyContent: 'start'}}
                                            iconProps={{iconColor: Colors.newDesign.mainBlue, iconHoverColor: Colors.newDesign.mainBlueHover}}
                            />
                            {isBoxInTrial() && <ProTipBox text={t('appointment-user-select-tip')}/>}
                        </VStack>
                    }
                    <BasicInformation withoutWrapper={true} {...props}/>
                </Box>
            </VStack>
            <VStack space={'1rem'}>
                <AppText fontSize={GlobalStyleAttributes.fonts.heading2Mobile} boldFont>{t('timing-section-header')}</AppText>
                <Divider style={{ margin: 0 }}/>
                {
                    fromAvailability ?
                        <AvailabilitySlotSelection {...props}/>
                        :
                        <RepeatConfiguration {...props}/>
                }
            </VStack>
        </VStack>
    );
};

export default BasicInfoAppointment;
